import { useEffect } from 'react';
import { useViewportSize } from '../useViewportSize/useViewportSize.esm.js';

/**
 * this hook is used to force mobile soft-keyboards to be hidden by disabling and blurring all enabled inputs for as long as the hook is mounted
 * @param shouldHide - true when it needs to activate the hiding of the keyboard
 */ var useHideMobileKeyboard = function(shouldHide) {
    var isMobileViewport = useViewportSize().isMobileViewport;
    useEffect(function() {
        var fieldsToBlur = document.querySelectorAll("input[type=text]:enabled");
        if (shouldHide && isMobileViewport) {
            fieldsToBlur.forEach(function(input) {
                input.setAttribute("readonly", "readonly");
                input.setAttribute("disabled", "true");
                input.blur();
            });
        }
        return function() {
            fieldsToBlur.forEach(function(input) {
                input.removeAttribute("readonly");
                input.removeAttribute("disabled");
            });
        };
    }, [
        isMobileViewport,
        shouldHide
    ]);
};

export { useHideMobileKeyboard };
